// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../../uikit/atoms/Icon/IconV5.bs.js");
let DialogV5 = require("../../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");

function ClientPageMatchPopup(props) {
  let onDismiss = props.onDismiss;
  let title = props.title;
  return JsxRuntime.jsx(DialogV5.make, {
    isOpen: props.isOpen,
    ariaLabel: title,
    onDismiss: () => onDismiss(),
    customContent: true,
    size: props.targetType === "clientNeed" ? "LgWide" : "XlWide",
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: title,
              className: "text-2xl leading-6 font-semibold text-zinc-700"
            }),
            JsxRuntime.jsx(ReactAriaComponents.Button, {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "cancel",
                className: "text-zinc-400"
              }),
              className: param => "relative flex items-center hover:cursor-pointer before:content-[''] before:block before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:w-[42px] before:h-[42px] hover:before:bg-zinc-100",
              onClick: param => onDismiss(),
              type: "button"
            })
          ],
          className: "flex items-center justify-between border-b-2 border-zinc-200 p-6"
        }),
        JsxRuntime.jsx("div", {
          children: props.children,
          className: "overflow-auto"
        }),
        JsxRuntime.jsx("div", {
          children: props.actions,
          className: "flex justify-end bg-zinc-100 px-4 py-2 rounded-b-md"
        })
      ],
      "aria-label": title,
      role: "dialog"
    })
  });
}

let make = ClientPageMatchPopup;

exports.make = make;
/* IconV5 Not a pure module */
